import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  appHeader: {
    backgroundColor: "#282c34",
    minHeight: "5vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "calc(10px + 2vmin)",
    color: "white",
    marginBottom: "5vh",
    textAlign: "center",
    padding: "12px",
  },
  wrapperClass: {
    // Corrected class name
    padding: "1rem",
    border: "1px solid #ccc",
  },
  editorClass: {
    // Corrected class name
    backgroundColor: "#dedede2e",
    padding: "1rem",
    border: "1px solid #dedede",
  },
  toolbarClass: {
    // Corrected class name
    border: "1px solid #ccc",
  },
}));

export default useStyles;
